var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyTaskActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_27_164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999931 0.99993H23V23H0.999931V0.99993Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_27_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 12.1408C22.2812 17.7414 17.741 22.2815 12.1405 22.2815C6.54 22.2815 1.99986 17.7414 1.99986 12.1408C1.99986 6.54031 6.54 2.00018 12.1405 2.00018C17.741 2.00018 22.2812 6.54031 22.2812 12.1408Z",
    fill: "#267072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2548 9.11775L10.4895 14.8831L7.74498 12.1385",
    stroke: "#EFEFEF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTaskActive);
export default __webpack_public_path__ + "static/media/my_task_active.b897be9f578bd64f94d2aaa68cd15f85.svg";
export { ForwardRef as ReactComponent };